export default function extractFilename(fileUrl) {
    let filename = '';

    if (fileUrl === '') {
        return '';
    }
    // local path
    if (fileUrl.indexOf('\\') > -1) {
        const pos = fileUrl.lastIndexOf('\\');
        if (pos > -1) {
            filename = fileUrl.substring(pos + 1, fileUrl.length);
        } else {
            filename = fileUrl;
        }
    }

    // url path
    if (fileUrl.indexOf('/') > -1) {
        const pos = fileUrl.lastIndexOf('/');
        if (pos > -1) {
            filename = fileUrl.substring(pos + 1, fileUrl.length);
        } else {
            filename = fileUrl;
        }
    }

    return filename;
}

export function getFileExtension(filename) {
    if (filename.indexOf('.') === -1) return '';

    const pos = filename.lastIndexOf('.');
    let extension = filename.substring(pos);
    if (extension.length === 1) return '';

    extension = extension.substring(1); // trim leading first character
    return extension;
}

export function getFilenameWithoutExtension(filename) {
    if (filename.indexOf('.') === -1) return filename;

    const pos = filename.lastIndexOf('.');
    return filename.substring(0, pos);
}
